import { render } from "./WidgetSearchVab.vue?vue&type=template&id=63a1d3e9&scoped=true&ts=true"
import script from "./WidgetSearchVab.vue?vue&type=script&lang=ts"
export * from "./WidgetSearchVab.vue?vue&type=script&lang=ts"

import "./WidgetSearchVab.vue?vue&type=style&index=0&id=63a1d3e9&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a1d3e9"]])

export default __exports__